import React, { useState } from 'react';
import { ReactSVG } from 'react-svg';
import TableHeader from './TableHeader';
import styles from './Table.module.css';
import { Icons } from '@/assets';

const TableEx = ({
  data,
  columns,
  getRowStyle,
  checkBox,
  isLiveUnload,
  onClickeditSizeAndSsl,
  onClickeditSizeAndSslLoadContainers,
}) => {
  const [selectedData, setSelectedData] = useState([]);
  const getCellValue = (col, val, row) => {
    if (col.component) {
      return <col.component value={val} {...row} />;
    }
    return val;
  };
  return (
    <div className={styles.tableContainer}>
      <table
        className={styles.table}
        // style={{ width: isLiveUnload ? '50%' : '100%' }}
      >
        <TableHeader columns={columns} />
        <tbody>
          {data?.map((row) => {
            const isDataSelected = selectedData.includes(row.id);
            return (
              <tr key={row.id} className={styles.tableRow}>
                {checkBox && (
                  <td className={styles.checkboxCell}>
                    <input
                      type="checkbox"
                      checked={isDataSelected}
                      onChange={() => {}}
                    />
                  </td>
                )}
                {columns?.map((col) => {
                  if (col.field === 'size' || col.field === 'ssl') {
                    return (
                      <td key={col.field} className={styles.tableCell}>
                        {isLiveUnload === true ? (
                          <div
                            onClick={
                              row.id
                                ? onClickeditSizeAndSslLoadContainers
                                : onClickeditSizeAndSsl
                            }
                            className={styles.cellContainer}>
                            {row[col.field]}
                            <ReactSVG
                              className={styles.penIcon}
                              src={Icons.pen}
                            />
                          </div>
                        ) : (
                          row[col.field]
                        )}
                      </td>
                    );
                  }

                  return (
                    <td key={col.field} className={styles.tableCell}>
                      {getCellValue(col, row[col?.field], row) || '-'}
                    </td>
                  );
                })}
              </tr>
            );
          })}
        </tbody>
      </table>
    </div>
  );
};

export default TableEx;
